import React, { useState, useEffect, useContext, Component } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet';
import Header from '../components/Header'
import Footer from '../components/Footer';
import axiosInstance from '../../axiosInstance';
import getDecryptData from '../../helper/getDecryptData';
import LoadingScreen from '../components/LoadingScreen';

const ProfileView = () => {
 const mydata = getDecryptData();
 const userId = mydata?._id;

  const [loading, setloading] = useState(true);

  const [Page, setPage] = useState({});
  const { id } = useParams();


  const getData = async () => {
 
    try {
      const { data } = await axiosInstance.get(`/get-user?userId=${id}`);
      const { success, token, existingUser, message } = data;
      setPage(existingUser);

      console.log('setPagesetPagesetPage',existingUser)
      // Delay the execution of buildScript by 1 secon
    }
    catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }


  };




  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, [id]);


    const sendFriend = async (recId) => { 
      if(!recId){
        toast.error('Please Login First!');
        return;
      }
    const finalData = {
      senderId: id,
      receiverId : recId
    }
    setloading(true);
    try {
      const  {data}   = await axiosInstance.post(`/send-request`,finalData);
  
         console.log('datadata',data)

      const {success} = data;
      if(success){
      toast.success('Add connection successfully');

       } 
      // Delay the execution of buildScript by 1 secon
    }
    catch (error) {
      console.log(error);
    toast.error(error.response.data.message ?? 'Getting error');
    } finally {
       setloading(false);
      getData();
    }
 
  };

   const cancelFriend = async (recId) => {


    const finalData = {
      senderId: recId,
      receiverId : id
    }
    setloading(true);
    try {
      const  {data}   = await axiosInstance.post(`/reject-request`,finalData);
  
 
      const {success} = data;
     console.log('datadata',data)

      if(success){
      toast.success('Cancel connection successfully');

       } 
      // Delay the execution of buildScript by 1 secon
    }
    catch (error) {
      console.log(error);
    toast.error(error.response.data.message ?? 'Getting error');
    } finally {
       setloading(false);
      getData();
    }
 
  };




  return (
    <>
      <Header />
   
      <main className="page whitesmoke py-4">
   <div className="container " >

         {(!loading && Page ) ? 
       <>
         {/* Profile details */}
  <section className='mt-4 pt-4 mb-3'>
    <div className="d-flex align-items-end justify-content-between flex-wrap mb-3">
      <div
        className="d-flex align-items-end gap-3 avatar-wrap"
       >
        <div className="position-relative">
          <img
            className=" rounded-circle"
            src="https://images.unsplash.com/photo-1527980965255-d3b416303d12?q=80&w=600&auto=format&fit=crop"
            alt="Profile"
            width={150}
            height={150}
          />
          <span
            className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle p-2"
            style={{
              right: 12,
              bottom: 18,
              width: 38,
              height: 38,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "3px solid #fff"
            }}
          >
            <i className="bi bi-check-lg" />
          </span>
        </div>
        <div>
          <h2 className="h4 mb-1">
           {Page.username ?? 'anonymous'}
           </h2>
          <div className="small text-muted">
            <span className="me-3">
              <i className="bi bi-geo-alt" />   {Page.statename ? Page.statename + ' India' : 'India'}
            </span>
            <span className="me-3">
              <i className="bi bi-briefcase" /> Product Designer @ OnTech
            </span>
            <span>
              <i className="bi bi-people" />  {Page?.friends?.length ?? 0} friends
            </span>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center gap-2 mt-3">

              { Page.friendRequests && Page.friendRequests.includes(userId) ? 
              
                             <button
                          type="button"
                          className='btn btn-danger btn-sm'
                          onClick={()=>{cancelFriend(userId)}}
                        >
                          <i className="ri-close-fill" /> Cancel Connection
                        </button> :   
                        ( Page.friends && Page.friends.includes(userId) ? 
                <Link to={`/chat/${Page._id}`}
          className="btn btn-dark btn-sm"
         
        >
          <i className="bi bi-messenger me-1" /> Message
        </Link>   :     <button
                          type="button"
                          className='btn btn-primary btn-sm'
                          onClick={()=>{sendFriend(userId)}}
                        >
                          <i className="ri-add-fill" /> Add Connection
                        </button>
              )
             
                        }

 
  
      
      </div>
    </div>
    {/* Tabs */}
    <div className="mt-3">
      <ul className="nav nav-pills">
        
        <li className="nav-item">
          <a className="nav-link active" data-bs-toggle="pill" href="#tabAbout">
            <i className="bi bi-info-circle me-1" /> About
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-bs-toggle="pill" href="#tabFriends">
            <i className="bi bi-people me-1" /> Friends
          </a>
        </li>
        {/* <li className="nav-item">
          <a className="nav-link" data-bs-toggle="pill" href="#tabPhotos">
            <i className="bi bi-images me-1" /> Photos
          </a>
        </li> */}
       
      </ul>
    </div>
  </section>
 
    {/* About Section */}
    <section id="tabAbout" className="tab-pane fade show active">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">About  {Page.username ?? 'anonymous'} </h5>
          <p className="mb-4">
            Designer obsessed with clean UI, coffee rituals, and long rides.
            Helping teams ship delightful products.
          </p>
          <div className="row g-3 small">
            <div className="col-md-6">
              <i className="bi bi-envelope me-2" />
               {Page.email ?? 'not Found'} 
            </div>
            <div className="col-md-6">
              <i className="bi bi-telephone me-2" />
              +91 {Page.phone ?? 'not Found'} 
            </div>
            <div className="col-md-6">
              <i className="bi bi-calendar3 me-2" />
              Joined {Page.startdate} 
            </div>
            <div className="col-md-6">
              <i className="bi bi-map me-2" />
             {Page.address ?? 'not Found'} 
            </div>
          </div>
        </div>
      </div>
    </section>
    
        {/* About Section */}
    <section id="tabFriends" className="tab-pane fade ">
      <div className="card">
        <div className="card-body">
         <div className="row">
  <div className="col-md-12">
    <div className="row gy-3">
      <div className="col-md-3 col-12">
        <div className="card border rounded-4 overflow-hidden" style={{}}>
          <div className="card-body p-2">
            <div className="row gap-3">
              <div className="col-12">
                <a href="/seller/6839505cd57f67fd3cf2e2a3">
                  <img
                    src="/assets/img/profile-pic.jpg"
                    className="w-100 rounded"
                    style={{ aspectRatio: "1 / 1", objectFit: "cover" }}
                  />
                </a>
              </div>
              <div className="flex-grow-1">
                <h4 className="h4 fw-medium mt-1 mb-1">
                  <a
                    className="text-decoration-none"
                    href="/seller/6839505cd57f67fd3cf2e2a3"
                  >
                    {" "}
                    anonymous
                  </a>
                </h4>
                <div className="text-muted small mb-1">
                  <i className="ri-map-pin-line" /> India
                </div>
                <div className="d-flex gap-2 mt-1 pt-0">
                  <a
                    className="btn btn-outline-primary btn-sm"
                    href="/profile/68cea1b50ed32d59b3e8bfb3"
                  >
                    View Details
                  </a>
                  <a
                    type="button"
                    className="btn btn-dark  btn-sm"
                    href="/profile.php"
                  >
                    <i className="ri-add-fill" /> Add Connection
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

        </div>
      </div>
    </section>

       </>
  
   : <LoadingScreen/> }


   </div>


      </main >
 
      <Footer />
    </>

  )
}

export default ProfileView